<template>
	<div class="tab-content">
		<div class="tab-pane fade show active" v-if="!loading">
			<form class="py-3 text-right">
				<div>
					<input class="border shadow-none p-2 col-6 " type="text" placeholder="Find a User" v-model="input" v-on:keyup="myFunction">
					<i class="fas fa-search"></i>
				</div>
			</form>
			<!-- {{users[0]}} -->
			<table class="table table-bordered m-0">
				<thead class="bg-light">
					<tr>
						<th class="text-center" scope="col">No</th>
						<th class="text-center" scope="col">Username</th>
						<th class="text-center" scope="col">Active</th>
					</tr>
				</thead>
				<tbody ref="myTable">
					<tr class="p-0" v-for="(user, i) in users" v-bind:key="i" v-if="user" ref="tr">
						<td>{{i+1}}</td>
						<td ref="td">{{user.username}}</td>
						<td class="text-center py-1"><button type="button" class="btn" :class="user.active ? 'btn-success' : 'btn-danger'" v-on:click="deactive(user.id)" v-if="user.active">Active</button>
						<button type="button" class="btn" :class="user.active ? 'btn-success' : 'btn-danger'" v-on:click="active(user.id)" v-else>Deactive</button>
						</td>
					</tr>
				</tbody>
			</table>

			<div class="d-flex my-2 justify-content-between">
				<div>
					<button class="btn btn-primary" v-on:click="Previous" v-if="page >= 2">Previous</button>
				</div>
				<div>
					<button class="btn btn-primary" v-on:click="next">Next</button>
				</div>
				
			</div>

		</div>
		<div v-else>
			<h3>Loading...</h3>
		</div>
	</div>
</template>
<script>
	import axios from 'axios'
	import App from '@/App'

	export default {
		data() {
			return {
				url: App.data().url,
				loading: true,
				users: [],
				input: '',
				page : 1
			}
		},
		mounted() {
			var pathQuery = '?' + 'page' + '=' + this.$route.query.page + '&' + 'size' + '=' + this.$route.query.size

			axios.get(this.url.limitUser + pathQuery).then((res) => {
				if(res.status === 200){
					this.users = res.data.result
				}
			})
			.catch(err => {
				alert('Error');
				console.log(err)
			})
			.then(() => {
				this.loading = false;
			})
		},
		methods: {
			myFunction() {
				var input = this.input;
				var filter = input.toUpperCase();
				var table =  this.$refs.myTable;
				var tr = this.$refs.tr;

				for (var i = 0; i < tr.length; i++) {
					var td = tr[i].getElementsByTagName("td")[1];
					if (td) {
						var txtValue = td.textContent || td.innerText;
						if (txtValue.toUpperCase().indexOf(filter) > -1) {
							tr[i].style.display = "";
					} else {
						tr[i].style.display = "none";
						}
					}       
				}
			},
			deactive(i){
				var params = {
					headers: {
						'x-access-token': localStorage.getItem('eclass-token')
					}
				}

				axios.put(this.url.deactive + i ,{}, params).then(res => {
					console.log(res)
					alert("Success")
					window.location.reload()
				}).catch(err =>{
					console.log(err)
					alert("Failed")
				})
			},
			active(i){
				var params = {
					headers: {
						'x-access-token': localStorage.getItem('eclass-token')
					}
				}

				axios.put(this.url.active + i ,{}, params).then(res => {
					console.log(res)
					alert("Success")
					window.location.reload()
				}).catch(err =>{
					console.log(err)
					alert("Failed")
				})
			},
			next() {

				this.page++
				this.$router.replace({
					name: 'user', query: {page: + this.page ,size: 10}
				})
				var pathQuery = '?' + 'page' + '=' + this.$route.query.page + '&' + 'size' + '=' + this.$route.query.size

				axios.get(this.url.limitUser + pathQuery).then((res) => {
					if(res.status === 200){
						this.users = res.data.result
					}
				})
				.catch(err => {
					alert('Error');
				})
				.then(() => {
					this.loading = false;
				})
			},
			Previous(){
				

				if(this.page > 1){
					this.page--
					this.$router.replace({
						name: 'user', query: {page:  + this.page, size: 10}
					})
				}

				var pathQuery = '?' + 'page' + '=' + this.$route.query.page + '&' + 'size' + '=' + this.$route.query.size

				axios.get(this.url.limitUser + pathQuery).then((res) => {
					if(res.status === 200){
						this.users = res.data.result
					}
				})
				.catch(err => {
					alert('Error');
				})
				.then(() => {
					this.loading = false;
				})
			}
		}
	}
</script>